import styled from "styled-components/macro";
import { Box } from "@mui/material";

/* istanbul ignore next */
export const SelectBox = styled(Box)`
  gap: ${(props): string => props.theme.spacing(0.5)};
  display: flex;
  flex-wrap: wrap;
`;
